// move all css to css/app.ts
// import '../css/lato.css'
// import '../css/panwds.scss'
// import '@sparky/panwds-tw-scoped-css/dist.css'

import * as dateFns from 'date-fns'
import * as ReactTable from 'react-table'
import * as reactFocusOn from 'react-focus-on'
import * as reactHookForm from 'react-hook-form'
import * as PanWDSTailwindcss from '@panwds/tailwindcss'
import * as PanWDSReactUI from '@panwds/react-ui'
import * as PanWDSReactTable from '@panwds/react-table'
import * as PanWDSReactForm from '@panwds/react-form'
import * as PanWDSReactFilters from '@panwds/react-filters'
import * as PanWDSReactNav from '@panwds/react-nav'

import {
  PanWDSTailwindcss as PanWDSTailwindcssLegacy,
  PanWDSReactUI as PanWDSReactUILegacy,
  PanWDSReactTable as PanWDSReactTableLegacy,
  PanWDSReactFilters as PanWDSReactFiltersLegacy,
  PanWDSReactForm as PanWDSReactFormLegacy,
} from '@sparky/panwds-legacy'

import * as PanWDSReactFiltersV3 from '@sparky/panwds-v4-delta/react-filters-v3'
import {
  Drawer,
  Sidecar,
  SidecarBody,
  sidecarSizes,
  Breadcrumbs,
  Popover,
} from '@sparky/panwds-v4-delta/react-ui-delta'

import {
  PanWDSReactUI as PanWDSReactUIV6,
  PanWDSReactTable as PanWDSReactTableV5,
  PanWDSReactFilters as PanWDSReactFiltersV4,
  PanWDSReactForm as PanWDSReactFormV3,
} from '@sparky/panwds-v6'

import {
  PanWDSReactUI as PanWDSReactUIV8,
  PanWDSReactTable as PanWDSReactTableV6,
  PanWDSReactFilters as PanWDSReactFiltersV6,
  PanWDSReactForm as PanWDSReactFormV5,
} from '@sparky/panwds-v8'

const PanWDSReactUIV5Compat: unknown = {
  Drawer,
  Sidecar,
  SidecarBody,
  sidecarSizes,
  ...PanWDSReactUIV6,
  Breadcrumbs,
  Popover,
}

export { Portal as PanWDSReactPortal } from '@panwds/react-ui'
export {
  dateFns,
  reactFocusOn,
  reactHookForm,
  ReactTable,
  // PanWDSTailwindcss as tailwindcss,
  // PanWDSTailwindcss,
  // PanWDSReactUI,
  // PanWDSReactTable,
  // PanWDSReactFilters,
  // PanWDSReactForm,
  PanWDSTailwindcssLegacy,
  PanWDSReactUILegacy,
  PanWDSReactTableLegacy,
  PanWDSReactFiltersLegacy,
  PanWDSReactFormLegacy,
  PanWDSTailwindcssLegacy as tailwindcss,
  PanWDSTailwindcssLegacy as PanWDSTailwindcss,
  PanWDSReactUILegacy as PanWDSReactUI,
  PanWDSReactTableLegacy as PanWDSReactTable,
  PanWDSReactFiltersLegacy as PanWDSReactFilters,
  PanWDSReactFormLegacy as PanWDSReactForm,
  PanWDSReactUIV5Compat,
  PanWDSReactUIV6,
  PanWDSReactUIV6 as PanWDSReactUILatest,
  PanWDSReactTableV5,
  PanWDSReactTableV5 as PanWDSReactTableLatest,
  PanWDSReactFiltersV4,
  PanWDSReactFiltersV4 as PanWDSReactFiltersLatest,
  PanWDSReactFormV3,
  PanWDSReactFormV3 as PanWDSReactFormLatest,
  PanWDSReactUI as PanWDSReactUIV8,
  PanWDSReactTable as PanWDSReactTableV6,
  PanWDSReactFilters as PanWDSReactFiltersV6,
  PanWDSReactForm as PanWDSReactFormV5,
  PanWDSReactUIV8 as PanWDSReactUIV8Stable,
  PanWDSReactTableV6 as PanWDSReactTableV6Stable,
  PanWDSReactFiltersV6 as PanWDSReactFiltersV6Stable,
  PanWDSReactFormV5 as PanWDSReactFormV5Stable,
  PanWDSReactUI as PanWDSReactUIV8Latest,
  PanWDSReactTable as PanWDSReactTableV6Latest,
  PanWDSReactFilters as PanWDSReactFiltersV6Latest,
  PanWDSReactForm as PanWDSReactFormV5Latest,
  PanWDSReactFiltersV3 as PanWDSReactFiltersRounded,
  PanWDSReactFiltersV3,
  PanWDSReactNav,
  PanWDSReactNav as PanWDSReactNavLatest,
  PanWDSTailwindcss as PanWDSTailwindcssLatest,
  PanWDSTailwindcss as PanWDSTailwindcssV8,
  PanWDSTailwindcss as PanWDSTailwindcssV10,
  PanWDSTailwindcss as PanWDSTailwindcssV10Stable,
  PanWDSTailwindcss as PanWDSTailwindcssV10Latest,
}
